import { useEffect, useState } from "react";
import { getAccessToken, getAccessTokenSync, keycloak } from "./oidc";

/**
 * Returns a valid Keycloak access token, refreshing it if it expires within 30s.
 * Prefer this over AuthConfig.getToken() in React components — the sync getter
 * may return a stale token if the proactive onTokenExpired refresh hasn't fired yet.
 */
export const useKcToken = (): string | null => {
  const [token, setToken] = useState<string | null>(getAccessTokenSync);

  useEffect(() => {
    let active = true;
    getAccessToken().then((t) => {
      if (active) setToken(t);
    });
    const prev = keycloak.onAuthRefreshSuccess;
    keycloak.onAuthRefreshSuccess = () => {
      setToken(keycloak.token ?? null);
      prev?.();
    };
    return () => {
      active = false;
      keycloak.onAuthRefreshSuccess = prev;
    };
  }, []);

  return token;
};
